
<template>
<section>
  <div>
    <div class="columns">
      <div class="col">
        <chc-input v-model="data.created_at" :error="errors.created_at" label="Date" :required="true" type="date"></chc-input>
        <chc-input v-model="data.contact_name" :error="errors.contact_name" label="Contact Name" :required="true"></chc-input>
        <chc-input v-model="data.contact_method" :error="errors.contact_method" label="Contact Method" format="combo"
                   :autoCompleteValues="$store.state.constants.charity.contact_method"></chc-input>
        <chc-input v-model="data.text" :error="errors.notes" label="Notes"></chc-input>
        <div class="field left">
          <input @click="submit" type="submit" class="btn" value="Add to Contact Log">
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'

export default {
  name: 'CharityAddContact',
  data () {
    return {
      data: {
        date: null,
        contact_name: null,
        contact_method: null,
        note: ''
      },
      hasErrors: false,
      errors: {}
    }
  },
  props: ['charityId'],
  methods: {
    submit () {
      store.functions.charity.addContact(this.charityId, this.data,
        (errors) => {
          this.errors = errors
          this.hasErrors = true
        }).then(() => {
        this.hasErrors = false
        this.$emit('refresh')
        this.$emit('close')
      })
    }
  },
  computed: {
  }
}
</script>

<style scoped>

#buyer-status {
    width: 80%;
}

.field .left {
    padding-top: 4em;
}

section {
    width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/Charity/CharityAddContact.vue